<template>
  <message-template :direction="'outgoing'" :time="time" :channel="channel">
    <div class="log-image-map-block">
      <img v-if="hasImg" class="image" :src="imgSrc" :alt="imgAlt" />
      <img v-else src="@/assets/images/placeholder-square.jpg" alt="placeholder" />
    </div>
  </message-template>
</template>
<script>
import MessageTemplate from './MessageTemplate.vue';

export default {
  name: 'buttonTemplate',
  components: {
    'message-template': MessageTemplate,
  },
  props: {
    data: {
      type: Object,
    },
    time: {
      type: Number,
      default: 0,
    },
    channel: {
      type: String,
      default: '',
    },
    uid: {
      type: String,
    },
  },
  computed: {
    hasImg() {
      if (this.data && this.data.imageMap) {
        return true;
      }
      return false;
    },
    imgSrc() {
      if (this.data && this.data.imageMap) {
        return `${this.data.imageMap.baseUrl}/${this.data.imageMap.baseSize.width}`;
      }
      return '';
    },
    imgAlt() {
      if (this.data && this.data.imageMap) {
        return this.data.imageMap.altText;
      }
      return 'Image map';
    },
  },
};
</script>
<style lang="scss" scoped>
.log-image-map-block {
  max-width: 300px;
  overflow: hidden;
  background-color: #efefef;
  border-radius: 10px 10px 10px 10px;
  .image {
    width: 100%;
    height: auto;
  }
}
</style>
